// extracted by mini-css-extract-plugin
export default {"menuSectionLink":"LaQlwssYTpGClBQhTU8Q","icon":"b0FxfsHeVWdEgY5xCrMw","active":"RBK7wl9djvKe8WruRP4c","label":"XAuTW5hXJxiCE91j4Y8C","unreadCount":"lxdKGnPWVql4UX1IalIC"};